import React from 'react';
import { Container, Text } from 'components';

interface EdgeSubscriptionHistoryModalProps {
  subscriptionId: number;
}

const EdgeSubscriptionHistoryModal: React.FC<EdgeSubscriptionHistoryModalProps> = ({
  subscriptionId,
}) => {
  return (
    <Container style={{ padding: '24px' }}>
      <Text textStyle="h2" style={{ marginBottom: '16px' }}>
        Subscription History
      </Text>
      <Text>
        Viewing history for subscription with ID: {subscriptionId}
      </Text>
      <Text style={{ marginTop: '16px', color: '#666' }}>
        This is a placeholder for the history functionality. The history list will be implemented here.
      </Text>
    </Container>
  );
};

export default EdgeSubscriptionHistoryModal;
